/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import LogoRingSpinner from "./LogoRingSpinner";

type LoadingMode = "page" | "section" | "inline";
type LoadingSize = "sm" | "md" | "lg";

type LoadingProps = {
  mode?: LoadingMode;
  size?: LoadingSize;
  text?: string;
};

const sizeMap: Record<LoadingSize, number> = {
  sm: 80,
  md: 120,
  lg: 200,
};

const Loading: Component<LoadingProps> = ({
  mode = "inline",
  size = "md",
  text,
  className,
}) => {
  const spinnerSize = sizeMap[size];

  if (mode === "page") {
    return (
      <div
        className={className}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100vw",
          height: "100dvh",
          zIndex: 9999,
          background: "var(--surface-primary, #faf8f5)",
        }}
      >
        <LogoRingSpinner text={text} />
      </div>
    );
  }

  if (mode === "section") {
    return (
      <div
        className={className}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          paddingTop: "100px",
          paddingBottom: "100px",
          gridColumn: "1 / -1",
        }}
      >
        <LogoRingSpinner text={text} size={spinnerSize} />
      </div>
    );
  }

  return (
    <div
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LogoRingSpinner size={spinnerSize} />
    </div>
  );
};

export default Loading;
